const useNavigationMenuStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 0.5
        },
        backButtonContainer: {
            p: '12px',
            borderRadius: 2,
            backgroundColor: (theme) => theme.palette.background.paper
        },
        layoutTabsContainer: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            p: '12px',
            gap: 0.5,
            borderRadius: 2,
            backgroundColor: (theme) => theme.palette.background.paper
        }
    };
};
export default useNavigationMenuStyles;
